import React from "react";

const Microsoft = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path fill="#4CAF50" d="M19 17h15V3a1 1 0 0 0-1-1H19v15Z" />
        <path fill="#F44336" d="M17 17V2H3a1 1 0 0 0-1 1v14h15Z" />
        <path fill="#2196F3" d="M17 19H2v14a1 1 0 0 0 1 1h14V19Z" />
        <path fill="#FFC107" d="M19 19v15h14a1 1 0 0 0 1-1V19H19Z" />
    </svg>
);

export default Microsoft;
